import { setStateParamsType } from '@Constants/StateParamsConstants';
import { stateParams as stateParamsSelector } from '@Selectors/StateParamsSelectors';

export function setStateParams (stateParams) {
  return (dispatch, getState) => {
    const state = getState();
    const previousStateParams = stateParamsSelector(state);

    dispatch({
      type: setStateParamsType,
      payload: {
        stateParams,
        previousStateParams,
      },
    });
  };
}
